import { MutationFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const postTableRowData: MutationFunction<
  void,
  { contentId: string; files: File[]; data: Record<string, unknown> }
> = async ({ contentId, files, data }) => {
  const response = await portalGatewayClient.table.postTableRowData(contentId, {
    files,
    data,
  });

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error creating row'),
      response
    );
  }
};
